class SafeLoadScripts extends HTMLElement {
  constructor() {
    super();
  }


  connectedCallback() {
    if (this.dataset.processed) return;
    this.dataset.processed = 'true';

    // Use Array.from(this.children) to find direct script children safely
    const scripts = Array.from(this.children).filter(child => child.tagName === 'SCRIPT');

    scripts.forEach((script) => {
      const key = script.dataset.flowLoadKey;

      if (key && window.wetheme && window.wetheme.webcomponentRegistry) {
        const scriptLoaded = window.wetheme.webcomponentRegistry.checkScriptLoaded(key);
        if (!scriptLoaded) {
          const postLoadedScript = document.createElement('script');
          const { src, defer, async, type } = script;
          postLoadedScript.src = src;
          postLoadedScript.defer = defer;
          postLoadedScript.async = async;
          postLoadedScript.type = type;
          // Mark as module if needed, though 'type' covers it usually

          // Append to document.body or head to ensure it persists and isn't affected by local DOM thrashing
          document.body.appendChild(postLoadedScript);
        }
      }
    });

  }
}

customElements.define('safe-load-scripts', SafeLoadScripts);